<template>
  <div class="page">
    <div class="file-form">
      <h2 class="title">举办大型展览展销活动资料提交</h2>
      <p class="subtitle">请按要求上传以下全部材料，确保不遗漏任何一项。</p>

      <!-- 基础信息录入 -->
      <h3 class="section-title">基础信息</h3>

      <div class="basic-info">
        <div class="form-row">
          <label class="form-label">活动名称</label>
          <input
              class="form-input"
              type="text"
              v-model="basicInfo.eventName"
              placeholder="请输入活动名称"
          />
        </div>

        <div class="form-row">
          <label class="form-label">所在场馆</label>
          <input
              class="form-input"
              type="text"
              v-model="basicInfo.venue"
              placeholder="请输入所在场馆"
          />
        </div>

        <div class="form-row">
          <label class="form-label">联系人姓名</label>
          <input
              class="form-input"
              type="text"
              v-model="basicInfo.contactName"
              placeholder="请输入联系人姓名"
          />
        </div>

        <div class="form-row">
          <label class="form-label">联系人电话</label>
          <input
              class="form-input"
              type="tel"
              v-model="basicInfo.contactPhone"
              placeholder="请输入联系人电话"
          />
        </div>

        <div class="form-row">
          <label class="form-label">预期人数</label>
          <input
              class="form-input"
              type="number"
              min="1"
              v-model.number="basicInfo.expectedPeople"
              placeholder="请输入预期人数"
          />
        </div>
      </div>

      <h3 class="section-title">文件列表</h3>

      <div
          v-for="item in files"
          :key="item.id"
          class="file-row"
      >
        <div class="file-info">
          <div class="file-icon"></div>
          <div class="file-text">
            <div class="file-name">{{ item.name }}</div>
            <div class="file-extra" v-if="item.fileName">
              已选择：{{ item.fileName }}
            </div>
          </div>
        </div>

        <div class="file-actions">
          <button
              class="btn btn-primary"
              type="button"
              @click="downloadTemplate(item)"
          >
            模板下载
          </button>

          <button
              class="btn btn-ghost btn-disabled"
              type="button"
              disabled
          >
            范文下载
          </button>

          <input
              class="file-input"
              type="file"
              :ref="'fileInput' + item.id"
              @change="onFileChange($event, item)"
          />
          <button
              class="btn btn-upload"
              type="button"
              @click="triggerUpload(item)"
          >
            上传
          </button>

          <span
              class="status-tag"
              :class="item.uploaded ? 'status-success' : 'status-pending'"
          >
            {{ item.uploaded ? '已上传' : '未上传' }}
          </span>
        </div>
      </div>

      <div class="form-footer">
        <button class="btn btn-submit" type="button" @click="submitForm">
          提交
        </button>
      </div>
    </div>

    <!-- 浮动按钮：我需要代办服务 -->
    <button class="floating-btn" type="button" @click="handleAgency">
      我需要
      <br>代办服务
    </button>
  </div>
</template>

<script>
export default {
  name: 'FileListForm',
  data() {
    return {
      basicInfo: {
        eventName: '',
        venue: '',
        contactName: '',
        contactPhone: '',
        expectedPeople: null
      },
      files: [
        { id: '1-1', name: '1.1、大型群众性活动安全许可申请报告', uploaded: false, fileName: '' },
        { id: '1-2', name: '1.2、商务部备案说明', uploaded: false, fileName: '' },
        { id: '2',   name: '2、主、承办协议', uploaded: false, fileName: '' },
        { id: '3',   name: '3、搭建服务合同、安全生产管理协议', uploaded: false, fileName: '' },
        { id: '3-1', name: '3.1、搭建单位资质证明', uploaded: false, fileName: '' },
        { id: '3-2', name: '3.2、搭建公司营业执照', uploaded: false, fileName: '' },
        { id: '3-3', name: '3.3、搭建安全保障书', uploaded: false, fileName: '' },
        { id: '3-4', name: '3.4、安保服务合同（搭建期间）', uploaded: false, fileName: '' },
        { id: '3-5', name: '3.5、安保服务合同（活动期间）', uploaded: false, fileName: '' },
        { id: '4',   name: '4、场地确认函', uploaded: false, fileName: '' },
        { id: '4-1', name: '4.1、场地用电说明', uploaded: false, fileName: '' },
        { id: '4-2', name: '4.2、场地安检设施情况说明', uploaded: false, fileName: '' },
        { id: '4-3', name: '4.3、设备租赁合同', uploaded: false, fileName: '' },
        { id: '5',   name: '5、安全工作方案、安全风险评估', uploaded: false, fileName: '' },
        { id: '5-1', name: '5.1、安保方案报部门审验盖章', uploaded: false, fileName: '' },
        { id: '5-2', name: '5.2、现场平面图', uploaded: false, fileName: '' },
        { id: '5-5', name: '5.5、应急预案', uploaded: false, fileName: '' },
        { id: '5-6', name: '5.6、安保公司安检工作方案', uploaded: false, fileName: '' },
        { id: '5-7', name: '5.7、安保公司安检突发事件处置预案', uploaded: false, fileName: '' },
        { id: '5-8', name: '5.8、安保公司安保、劝退、应急方案', uploaded: false, fileName: '' },
        { id: '5-9', name: '5.9、安保公司资质、营业执照、法人身份证复印件', uploaded: false, fileName: '' }
      ]
    };
  },
  methods: {
    triggerUpload(item) {
      const ref = this.$refs['fileInput' + item.id];
      const input = Array.isArray(ref) ? ref[0] : ref;
      if (input) {
        input.click();
      }
    },
    onFileChange(event, item) {
      const file = event.target.files[0];
      if (file) {
        item.fileName = file.name;
        item.uploaded = true;
      } else {
        item.fileName = '';
        item.uploaded = false;
      }
    },
    downloadTemplate(item) {
      // 这里可以换成真实的下载地址
      // 例如：window.location.href = item.templateUrl;
      console.log('下载模板:', item.name);
      this.$message.info('仅限会员下载')
    },
    submitForm() {
      const notUploaded = this.files.filter(f => !f.uploaded);
      if (notUploaded.length > 0) {
        alert(
            '还有未上传的材料：\n' +
            notUploaded.map(f => '· ' + f.name).join('\n')
        );
        return;
      }
      // 在这里提交表单数据到后端
      console.log('提交的文件列表:', this.files);
      alert('资料已全部上传，可提交到后台。');
    },
    handleAgency() {
      // “我需要代办服务” 按钮的逻辑
      // 可以跳转到客服/在线咨询/填写需求弹窗等
      alert('已收到您的代办服务需求，我们会尽快与您联系。');
    }
  }
};
</script>

<style scoped>
.page {
  min-height: 100vh;
  background: #f5f7fa;
  padding: 24px 16px 40px;
  box-sizing: border-box;
}

.file-form {
  max-width: 960px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 8px;
  padding: 24px 24px 32px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
}

.basic-info {
  margin: 16px 0 24px;
  padding: 20px 24px;
 /* background: #f9fafb;*/
 /* border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(15, 23, 42, 0.04);*/
}

.section-title {
  margin-bottom: 18px;
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  border-left: 3px solid #3b82f6;
  padding-left: 10px;
}

.form-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}

.form-label {
  flex-shrink: 0;
  width: 86px;
  font-size: 14px;
  color: #374151;
  text-align: right;
}

.form-input {
  flex: 1;
  height: 36px;
  padding: 6px 10px;
  border-radius: 4px;
  border: 1px solid #d1d5db;
  font-size: 14px;
  color: #111827;
  background-color: #fff;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;
}

.form-input::placeholder {
  color: #9ca3af;
}

.form-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);
  background-color: #fff;
}

.title {
  margin: 0;
  font-size: 20px;
  color: #1f2d3d;
}

.subtitle {
  margin: 8px 0 20px;
  font-size: 13px;
  color: #808695;
}

.file-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #f0f2f5;
}

.file-row:last-child {
  border-bottom: none;
}

.file-info {
  display: flex;
  align-items: flex-start;
  flex: 1;
  min-width: 0;
}

.file-icon {
  width: 20px;
  height: 24px;
  margin-right: 10px;
  border-radius: 2px;
  background: linear-gradient(135deg, #ff5b5b, #ff7875);
  position: relative;
}

.file-icon::after {
  content: '';
  position: absolute;
  right: 3px;
  top: 4px;
  width: 8px;
  height: 6px;
  border-radius: 1px;
  background: #ffffff;
}

.file-text {
  min-width: 0;
}

.file-name {
  font-size: 14px;
  color: #303133;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.file-extra {
  margin-top: 4px;
  font-size: 12px;
  color: #909399;
}

.file-actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-left: 16px;
}

.file-actions .btn + .btn,
.file-actions .btn + .status-tag {
  margin-left: 8px;
}

.file-input {
  display: none;
}

.btn {
  font-size: 13px;
  padding: 4px 10px;
  border-radius: 4px;
  border: 1px solid transparent;
  background: #ffffff;
  cursor: pointer;
  outline: none;
  transition: all 0.15s ease-in-out;
  white-space: nowrap;
}

.btn-primary {
  background: #409eff;
  border-color: #409eff;
  color: #ffffff;
}

.btn-primary:hover {
  background: #66b1ff;
  border-color: #66b1ff;
}

.btn-ghost {
  background: #ffffff;
  border-color: #dcdfe6;
  color: #909399;
}

.btn-ghost:hover {
  border-color: #c0c4cc;
}

.btn-disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-upload {
  background: #ffffff;
  border-color: #409eff;
  color: #409eff;
  margin-left: 10px;
}

.btn-upload:hover {
  background: #ecf5ff;
}

.btn-submit {
  min-width: 320px;
  height: 36px;
  font-size: 14px;
  background: #409eff;
  border-color: #409eff;
  color: #ffffff;
}

.btn-submit:hover {
  background: #66b1ff;
  border-color: #66b1ff;
}

.status-tag {
  font-size: 12px;
  padding: 2px 10px;
  border-radius: 10px;
  border: 1px solid #dcdfe6;
}

.status-success {
  color: #67c23a;
  background: #f0f9eb;
  border-color: #c2e7b0;
}

.status-pending {
  color: #909399;
  background: #f4f4f5;
  border-color: #e4e7ed;
}

.form-footer {
  margin-top: 24px;
  text-align: center;
}

/* 浮动按钮样式 */
.floating-btn {
  position: fixed;
  right: 0px;
  bottom: 40%;
  padding: 10px 18px;
  border-radius: 999px;
  border: none;
  background: #ff8a00;
  color: #ffffff;
  font-size: 14px;
  cursor: pointer;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18);
  outline: none;
  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
  z-index: 1000;
}

.floating-btn:hover {
  background: #ffa033;
  transform: translateY(-1px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
}
</style>
